import React from 'react';

interface PlaceholderPageProps {
    title: string;
}

const PlaceholderPage: React.FC<PlaceholderPageProps> = ({ title }) => (
    <div style={{ padding: 24 }}>
        <h1>{title} (placeholder)</h1>
        <p>This page will be migrated in a later phase.</p>
    </div>
);

export default PlaceholderPage;
